import { UsersThreeIcon as PhosphorUsersThreeIcon } from "@phosphor-icons/react/dist/ssr/UsersThree";

import { createAppIcon } from "@/components/createAppIcon";

export const GroupsIcon = /* @__PURE__ */ createAppIcon(PhosphorUsersThreeIcon);
